<span *ngIf="status<100">{{ status | number:'1.0-0' }}%</span>
<img src="./assets/ui/svg/multi-color/done.svg" *ngIf="status===100">
